module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/KY-c7e07f6c1c56ca76f9780cca3f61ad9e.png";